import { Link } from "@StarberryUtils";
import PropTypes from "prop-types";
import React,{useEffect, useState} from "react";
import { useLocation } from "@reach/router"
import Slider from 'react-slick';
import {Col, Row, Container } from 'react-bootstrap';
import  "../CaseStudies/CaseStudies.scss";
import studyImg1 from "../../../images/study-image01.jpg"
import studyImg2 from "../../../images/study-image02.jpg"
import studyImg3 from "../../../images/study-image03.jpg";
import studyBanner from "../../../images/study-banner-img.jpg";
import studyBanner376 from "../../../images/study-banner376.jpg";
import studyBanner768 from "../../../images/study-banner768.jpg";
import studyBanner992 from "../../../images/study-banner992.jpg";
import playButton from "../../../images/play-button.svg"
import pattern from "../../../images/pattern.png"
import VideoPlay from "../../Play/full-custom-video";
import ReactMarkdown from "react-markdown"
import ReactPlayer from 'react-player'
import $ from "jquery";
import { getSrc } from "gatsby-plugin-image"

// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const imageVariants = {
  hidden: {
    opacity: 0,
    scale: 1.2 
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.8
    }
  }
}

const playVariants = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const FullBannerVideo = (props) => {

    const [isPlay,setPlay] = useState(false);
    const [isPlaying,setPlaying] = useState(false);
    const [play, setPlayvideo] = useState(false);
    const [showHTMLVideo, setHTMLVideo] = React.useState(false);

    function playvideo() {
      setPlayvideo(true);

    }

     const trackerVideo = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Video Play Btn',
          'formType': event,
          'formId': 'Video Play',
          'formName': 'Video',
          'formLabel': 'Video'
        });
    }

    let image = getSrc(props.image)
    var {pathname} = useLocation()
    let isCarlton = pathname.includes("/carlton/");
    const title = props.content.replace( /(<([^>]+)>)/ig, '')
    const renderContent = () => (
      <>
        {isCarlton && props.url && <VideoPlay url={props.url} />}

        <div variants={titleVariants}>
          <ReactMarkdown source={props.content} allowDangerousHtml />
        </div>

        {!isCarlton && props.url && <VideoPlay url={props.url} />}
      </>
    );

    return(
      <>
          <div
            className="full-video-ban home-full-video-banner-block"
          >
            <div className="study-banner-wrp " id="study-banner-wrp">
              <div className="study-banner full-height-study-banner">
                  <picture>
                    <source media="(min-width:1699px)" srcset={image} />
                    <source media="(min-width:992px)" srcset={image} />
                    <source media="(min-width:768px)" srcset={image} />
                    <img loading="lazy" className="banner-img" src={image} alt={`${props.content.replace( /(<([^>]+)>)/ig, '')} - Martyn Gerrard`} variants={imageVariants}/>
                  </picture>
                  {props.style === "Full_Banner_Text_Middle_Left" ?
                    <div className="study-content left-middle">
                      <Row>
                        <Container>
                          <Col xl={9} lg={9} md={12} sm={12} xs={12}>
                            {renderContent()}
                          </Col>
                        </Container>
                      </Row>
                    </div>
                    :
                    <div className="study-content text-center">
                      {renderContent()}
                    </div>
                  } 
              </div>
            </div>
          </div>
      </>
    )
  }

export default FullBannerVideo